export default "__VITE_ASSET__BUqzvJCz__"